<template>
  <FsDialog
    v-model="exportProjectPopupShow"
    width="480px"
    title="Export PDF"
    class-name="export_project_popup"
    :close-modal="false"
    @close="handleDialogClose"
  >
    <CustomerForm v-if="isCustomer" ref="customerFormRef" :data="projectDetail" @close="hideDialog" />
    <TechnicianForm v-else-if="!isCustomer" @close="hideDialog" />
  </FsDialog>
</template>

<script setup lang="ts">
import { ref, watch, computed } from 'vue'
import { FsDialog } from 'fs-design'
import CustomerForm from './CustomerForm.vue'
import TechnicianForm from './TechnicianForm.vue'
import { getProjectDetail, getTemplatePopupList } from '@/api/modules/project'
import { queryPdfData } from '@/api/modules/pdfExport'
import { savePdfData } from '@/api/modules/pdfExport'
import { useProjectStore } from '@/store/project'
import { useUserStore } from '@/store/user'
import { storeToRefs } from 'pinia'
interface Project {
  id: number
  name: string
  templateId: number
  description: string
  area: string
  createdAt: string
  isShared: 0 | 1
  isCustomized: 0 | 1
  emails: string[]
  createdBy: string
  templateDescription: string
}

const isCustomer = computed(() => ['PURCHASER', 'EMPLOYEE'].includes(customersType.value))

const projectStore = useProjectStore()
const userStore = useUserStore()
const { exportProjectId, exportProjectPopupShow } = storeToRefs(projectStore)
const { customersType } = storeToRefs(userStore)

const customerFormRef = ref<InstanceType<typeof CustomerForm> | null>(null)

const projectDetail = ref<Project>({
  id: 0,
  name: '',
  templateId: 0,
  description: '',
  area: '',
  createdAt: '',
  isShared: 0,
  isCustomized: 0,
  emails: [],
  createdBy: '',
  templateDescription: '',
})

const hideDialog = async (formData?: any) => {
  console.log(formData, 'formData')
  console.log(isCustomer.value, 'isCustomer')
  // 如果是客户类型且有表单数据，则保存到后端
  if (isCustomer.value && formData) {
    try {
      // 创建一个副本用于保存，将 corporateLogo 对象转换为 URL 字符串
      const dataToSave = {
        ...formData,
        corporateLogo: formData.corporateLogoUrl || '', // 保存 URL 字符串而不是对象
      }

      // 移除不需要保存的字段
      delete dataToSave.corporateLogoUrl

      await savePdfData({
        projectId: exportProjectId.value,
        typeId: 1,
        exportData: JSON.stringify(dataToSave),
      })
      console.log('表单数据已保存')
    } catch (error) {
      console.error('保存表单数据失败:', error)
    }
  }

  projectStore.hideExportProjectPopup()
}

const handleDialogClose = async () => {
  // 弹窗关闭时，如果是客户类型，获取表单数据并保存
  if (isCustomer.value && customerFormRef.value) {
    const formData = customerFormRef.value.getFormData()
    await hideDialog(formData)
  } else {
    projectStore.hideExportProjectPopup()
  }
}

watch(
  () => exportProjectPopupShow.value,
  async newValue => {
    if (newValue) {
      try {
        const [projectDetailRes, templateListRes, cacheFormData] = await Promise.all([
          getProjectDetail({ id: exportProjectId.value }) as Promise<{ data: Project }>,
          getTemplatePopupList() as Promise<{ data: any }>,
          queryPdfData({ projectId: exportProjectId.value, typeId: 1 }),
        ])

        // 先设置基础项目信息

        // 如果有缓存的表单数据，合并到 projectDetail 中
        console.log(cacheFormData?.data?.exportData, 'cacheFormData?.data?.exportData')
        if (cacheFormData?.data?.exportData) {
          try {
            const cachedFormData = JSON.parse(cacheFormData.data.exportData)
            // 合并缓存数据到 projectDetail（保留缓存的表单字段）
            projectDetail.value = {
              ...projectDetail.value,
              ...cachedFormData,
              id: localStorage.getItem('currentProjectId'),
            }
            console.log('合并后的 projectDetail:', projectDetail.value)
          } catch (parseError) {
            console.error('解析缓存数据失败:', parseError)
          }
        } else {
          projectDetail.value = projectDetailRes.data as Project
          projectDetail.value.containTopologyPic = true
          projectDetail.value.containEquipmentList = true
          // 设置模板描述
          if (projectDetailRes?.data?.templateId) {
            const desc =
              templateListRes?.data?.[0]?.templateList?.find(
                (item: any) => item.id === projectDetailRes?.data?.templateId
              )?.description ?? ''
            projectDetail.value.templateDescription = desc
          } else {
            projectDetail.value.templateDescription = ''
          }
          console.log(projectDetail, 'projectDetail---detail接口')
        }
      } catch (err) {
        console.error('请求失败:', err)
      }
    }
  }
)
defineExpose({
  hideDialog,
})
</script>

<style lang="scss">
// PS: 因为 Teleport 的缘故，所以需要使用全局样式
.export_project_popup {
  .fs-dialog__content--box {
    display: flex;
    flex-direction: column;
    padding: 0 !important;
  }

  .export-project__title {
    margin-bottom: 12px;
    line-height: 22px;
    color: $text-primary;
    font-size: $font-size-base;
    font-weight: $font-weight-bold;
  }

  .export-project__divider {
    width: 100%;
    height: 1px;
    margin: 16px 0;
    background-color: $border-color-light;
  }

  .fs-input__wrapper {
    border-color: transparent;
    background-color: #f6f6f8 !important;
    box-shadow: none;
  }

  .fs-upload__box {
    height: 42px !important;
    line-height: 42px !important;
  }

  .fs-upload-box__uploadBtn {
    padding: 0 12px !important;
    height: 42px !important;
    border: none !important;
    background-color: transparent !important;
  }

  .fs-textarea__wrapper {
    border-color: transparent;
    background-color: #f6f6f8 !important;
    box-shadow: none;
  }

  .fs-textarea__number {
    top: -24px;
    bottom: auto;
    margin-top: 0;
  }
}
</style>

<style lang="scss" scoped></style>
